import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { PERMISSIONS } from '../../config/permissions';
import UsersManagement from '../../components/rbac/UsersManagement';
import PageBreadcrumbs from '../../components/common/PageBreadcrumbs';

/**
 * User Management Page
 * Main page for managing users and their role assignments
 */
export default function UserManagement() {
  const { hasPermission } = useAuth();

  // Check if user has access to this module
  const hasAccess = hasPermission(PERMISSIONS.RBAC_USER_MANAGEMENT_VIEW);

  if (!hasAccess) {
    return (
      <div className="min-h-0 flex flex-col flex-1 h-full">
        <div className="flex-1 min-h-0 overflow-y-auto p-4 sm:p-6">
          <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
            <h2 className="text-xl font-semibold text-red-800 mb-2">Access Denied</h2>
            <p className="text-red-600">
              You don't have permission to access this module. Contact your administrator.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm overflow-hidden min-h-0 flex flex-col flex-1 h-full">
      <div className="shrink-0">
        <PageBreadcrumbs />
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto p-3 sm:p-6">
        <UsersManagement />
      </div>
    </div>
  );
}
